import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Filter } from '../../all-tournaments/store/actions/allTournaments.action';
import { endpoints } from '../../utils/endpoints';
import { LeaderboardResponse } from '../models/api/responses/leaderboard.response';
import { LeaderboardStatsType } from '../models/enums/leaderboard.enum';

@Injectable({
    providedIn: 'root',
})
export class LeaderboardService {
    private http = inject(HttpClient);


    fetchLeaderBoardStatisticData(
        type: LeaderboardStatsType,
        filters: Filter
    ): Observable<LeaderboardResponse> {
        let params = new HttpParams();

        params = Object.keys(filters).reduce((p, param) => {
            if (Array.isArray(filters[param])) {
                (filters[param] as string[]).forEach((arrayParam) => {
                    p = p.append(param, arrayParam);
                });
            } else {
                p = p.append(param, filters[param] as string);
            }

            return p;
        }, params);

        return this.http.get<LeaderboardResponse>(
            endpoints.leaderboard.children.getLeaderBoardData(type),
            {
                params,
            }
        );
    }
}
